import {
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from '@aeCore/services/token.service';
import {
  isIeCall,
  isRefreshTokenCall,
} from '@aeCore/helpers/interceptor.helper';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (skipAuthInterceptor(req)) return next(req);
  const tokenService = inject(TokenService);

  const accessToken = tokenService.getAccessToken();
  if (accessToken) {
    req = addTokenToRequest(req, accessToken);
  }

  return next(req);
};

function addTokenToRequest(
  req: HttpRequest<unknown>,
  token: string,
): HttpRequest<unknown> {
  return req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
}

const skipAuthInterceptor = (req: HttpRequest<unknown>) => {
  return !isIeCall(req) || isRefreshTokenCall(req);
};
